import React, { useState, useEffect } from 'react';
import { Modal, Button, Select } from '@/components/ui';

interface UpdateRoleModalProps {
  isOpen: boolean;
  onClose: () => void;
  member: any;
  onUpdate: (roleId: string) => void;
}

export function UpdateRoleModal({ isOpen, onClose, member, onUpdate }: UpdateRoleModalProps) {
  const [selectedRole, setSelectedRole] = useState<string>('member');

  useEffect(() => {
    if (isOpen && member) {
      setSelectedRole(member.team_role_id || 'member');
    }
  }, [isOpen, member]);

  const handleUpdate = () => {
    if (selectedRole) {
      onUpdate(selectedRole);
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cập nhật quyền hạn" size="sm">
      <div className="p-4 space-y-4">
        {member && (
          <div className="bg-slate-50 p-3 rounded-md border border-slate-100">
            <p className="sm:text-sm text-xs text-slate-700 font-normal">
              Cập nhật quyền cho: <span className="font-normal text-emerald-600">{member.user.full_name}</span>
            </p>
          </div>
        )}
        <div className="space-y-1.5">
          <label className="sm:text-sm text-xs font-normal text-slate-700">Quyền hạn trong team</label>
          <Select
            value={selectedRole}
            onValueChange={setSelectedRole}
            options={[
              { value: 'foreman', label: 'Tổ trưởng' },
              { value: 'vice_foreman', label: 'Tổ phó' },
              { value: 'member', label: 'Thành viên' },
            ]}
          />
        </div>
        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100">
          <Button variant="outline" onClick={onClose}>Hủy</Button>
          <Button onClick={handleUpdate} disabled={!selectedRole} className="bg-emerald-800 hover:bg-emerald-900 text-white">
            Lưu thay đổi
          </Button>
        </div>
      </div>
    </Modal>
  );
}
